import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getOrders } from "../../redux/apiCalls"
import { format } from "timeago.js"
import { Visibility } from "@mui/icons-material"
// Components
import Table from "../Table/Table"
// Styles
import { Container, StyledLink } from "./Orders.styles"

const Orders = ({ userId }) => {
   const dispatch = useDispatch()
   const { t } = useTranslation()
   const orders = useSelector((state) => state.order.orders)

   useEffect(() => {
      getOrders(userId, dispatch)
   }, [userId, dispatch])

   const statusTranslation = {
      sent: t("orders.value.status.s1"),
      pending: t("orders.value.status.s2"),
      cancelled: t("orders.value.status.s3"),
   }

   const headers = [
      { name: t("orders.header.h1"), width: 10, align: "left" },
      { name: t("orders.header.h2"), width: 20, align: "left" },
      { name: t("orders.header.h3"), width: 15, align: "right" },
      { name: t("orders.header.h4"), width: 20, align: "right" },
      { name: t("orders.header.h5"), width: 15, align: "center" },
      { name: t("orders.header.h6"), width: 15, align: "center" },
   ]
   let data = []

   for (let i = orders.length - 1; i >= 0; i--) {
      data.push([
         orders[i].orderNumber,
         format(orders[i].createdAt),
         orders[i].totalQuantity,
         orders[i].amount + "€",
         statusTranslation[orders[i].status],
         <StyledLink to={`/order/${orders[i]._id}`}>
            <Visibility />
         </StyledLink>,
      ])
   }

   return (
      <Container>
         <Table headers={headers} data={data} pageSize={5} />
      </Container>
   )
}

Orders.propTypes = {
   userId: PropTypes.string,
}

export default Orders
